module.exports = __webpack_public_path__ + "static/media/clear-day.2aad2dce.svg";